<template>
  <v-card>
    <v-btn v-if="$keycloak.hasRealmRole('root')" @click="createNewstest" small
      >create</v-btn
    >
    <v-card-text v-if="newsStats">
      <h3><v-icon>local_library</v-icon>News</h3>
      <div
        v-for="newsItem in newsStats"
        :key="newsItem.id"
        style="margin-top: 10px"
      >
        <div style="color: #aa9999">
          {{ newsItem.timestamp | formatDateTime }}
        </div>
        <div class="newsItemBody">
          <read-more
            more-str="more"
            :text="newsItem.body"
            link="#"
            less-str="less"
            :max-chars="250"
          />
        </div>
        <div style="color: #aa9999; text-align: right">
          <EntityZ
            v-if="newsItem.user"
            :entity="newsItem.user"
            format="system"
          />
          <span v-if="!newsItem.user">{{ newsItem.userid }}</span>
        </div>
      </div>
      <v-dialog
        v-model="dialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="primary">
            <v-toolbar-title>
              <v-icon>notification_important</v-icon>Unseen news items
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <div v-for="newsunseen in newsUnseen" :key="newsunseen.newsitem.id">
              <span v-if="newsunseen.newsitem">{{
                newsunseen.newsitem.body
              }}</span>
              <v-btn @click="deleteNewsunseen(newsunseen)">Dismiss</v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-card-text>
  </v-card>
</template>

<script>
import DELETE_NEWS_UNSEEN from "@/graphql/extras/DeleteNewsUnseen";
import NEWS_STATS from "@/graphql/extras/NewsStats";
import NEWS_UNSEEN from "@/graphql/extras/NewsUnseen";
import NEWS_UPDATED from "@/graphql/extras/NewsUpdated";
import nbmlaw from "@/api/nbmlaw";
import EntityZ from "@/components/link/EntityZ";
export default {
  name: "News",
  apollo: {
    newsStats: {
      query: NEWS_STATS,
      subscribeToMore: {
        document: NEWS_UPDATED,
        updateQuery: (previousResult, { subscriptionData }) => {
          return {
            newsStats: [...subscriptionData.data.newsUpdated]
          };
        }
      }
    },
    newsUnseen: {
      query: NEWS_UNSEEN
    }
  },
  components: { EntityZ },
  computed: {
    dialog() {
      return this.newsUnseen && this.newsUnseen.length > 0;
    }
  },
  methods: {
    async deleteNewsunseen(newsunseen) {
      await this.$apollo.mutate({
        mutation: DELETE_NEWS_UNSEEN,
        variables: { newsitemid: newsunseen.newsitem.id },
        refetchQueries: [{ query: NEWS_UNSEEN }]
      });
    },
    async createNewstest() {
      await nbmlaw.post(`/cors/admin/extras/news/test`, null);
    }
  },
  watch: {
    newsStats: {
      handler() {
        this.$apollo.queries.newsUnseen.refetch();
      }
    }
  }
};
</script>

<style>
.newsItemBody {
  word-wrap: break-word;
}

.newsItemBody p {
  margin: 0;
  padding: 0;
  display: inline;
}
</style>
